module.exports = __webpack_public_path__ + "static/media/rtl-Creative-demo.b9456701.png";